import React, { useEffect } from "react";
import { WizardFormData } from "../types/wizard.types";

interface RankTrackingAppStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const RankTrackingAppStep: React.FC<RankTrackingAppStepProps> = ({
  onValidationChange,
}) => {
  useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  return (
    <div>
      <div className="tw-p-4 tw-bg-neutral-800/10 tw-rounded-lg">
        <p className="tw-text-neutral-800/80 tw-mb-3">
          Perfect for combat sports! Our rank tracking system helps you:
        </p>
        <ul className="tw-list-disc tw-list-inside tw-text-neutral-800/80 tw-space-y-1">
          <li>Monitor student belt progression</li>
          <li>Track training milestones and achievements</li>
          <li>Manage testing schedules and requirements</li>
          <li>Celebrate student accomplishments</li>
        </ul>
      </div>
    </div>
  );
};

export default RankTrackingAppStep;
